"use client";

import { api } from "@/convex/_generated/api";
import { Doc } from "@/convex/_generated/dataModel";
import { APP_NON_NGROK_DOMAIN } from "@/lib/constants/constants";
import { useQuery } from "convex/react";
import Link from "next/link";
import React from "react";
import { PricingShort } from "./pricing-short";
import { Button } from "../ui/button";
export const PricingShortLanding = () => {
  const plansData = useQuery(api.plans.getActivePlans, {});
  const displayPlans = React.useMemo(() => {
    if (!plansData?.data) return [];
    return (plansData.data as Doc<"plans">[]).filter(plan => plan.planType === "monthly" && plan.lookupKey !== "free_trial");
  }, [plansData]);
  return <>
      <PricingShort plans={displayPlans} isLandinPage={true} data-sentry-element="PricingShort" data-sentry-source-file="pricing-short-landing.tsx" />

      <div className="flex justify-center">
        <Link href={`${APP_NON_NGROK_DOMAIN}/pricing`} passHref legacyBehavior data-sentry-element="Link" data-sentry-source-file="pricing-short-landing.tsx">
          <Button variant={"link"} data-sentry-element="Button" data-sentry-source-file="pricing-short-landing.tsx">View All Plans</Button>
        </Link>
      </div>
    </>;
};